/** Maps resolve_booking_offer / RPC error codes to customer-facing Italian copy. */

export function describeUnavailableReason(code: string | undefined | null): string {
  const c = String(code || "").trim();
  switch (c) {
    case "same_day_booking_closed":
      return "Per prenotare il giorno stesso del servizio è necessario completare l’ordine prima delle 08:00 (ora Italia). Dopo quell’orario non è più possibile prenotare per oggi.";
    case "notice_below_minimum":
      return "Anticipo troppo breve: non è possibile prenotare con meno di 12 ore prima dell’inizio del servizio.";
    case "urgent_disabled_for_service":
      return "Questa fascia oraria richiede la modalità urgente, ma il venditore ha disabilitato le prenotazioni urgenti per questo servizio.";
    case "slot_unavailable":
      return "Questo slot non è disponibile o è al completo. Scegli un altro orario o giorno.";
    case "day_unavailable":
      return "Questo giorno non è disponibile per il venditore.";
    case "invalid_slot":
      return "Orario non valido. Seleziona una delle fasce disponibili.";
    case "missing_schedule":
      return "Data o orario mancanti.";
    case "booking_unavailable":
      return "Combinazione data/orario non prenotabile.";
    default:
      if (!c) return "Combinazione non prenotabile.";
      return c;
  }
}
